<template>
    <v-row class="code-inputs">
        <v-col>
            <v-text-field @focus="resetDigit(1)" @paste="handlePaste" maxlength="1" type="number" min="0" max="9" name="digit1" v-model="digit1" ref="digit1Input" :disabled="loading" :color="color ? color : 'primary'" outlined hide-details></v-text-field>
        </v-col>
        <v-col>
            <v-text-field @focus="resetDigit(2)" @paste="handlePaste" maxlength="1" type="number" min="0" max="9" name="digit2" v-model="digit2" ref="digit2Input" :disabled="loading" :color="color ? color : 'primary'" outlined hide-details></v-text-field>
        </v-col>
        <v-col>
            <v-text-field @focus="resetDigit(3)" @paste="handlePaste" maxlength="1" type="number" min="0" max="9" name="digit3" v-model="digit3" ref="digit3Input" :disabled="loading" :color="color ? color : 'primary'" outlined hide-details></v-text-field>
        </v-col>
        <v-col>
            <v-text-field @focus="resetDigit(4)" @paste="handlePaste" maxlength="1" type="number" min="0" max="9" name="digit4" v-model="digit4" ref="digit4Input" :disabled="loading" :color="color ? color : 'primary'" outlined hide-details></v-text-field>
        </v-col>
    </v-row>
</template>

<script>

// @ is an alias to /src

export default {
    name: 'digits-input',
    props: ['loading', 'autoFocus', 'color'],
    data(){
        return {
            digit1: '',
            digit2: '',
            digit3: '',
            digit4: '',
            isPasting: false,
        };
    },
    computed:{
        appLoadedOnce(){
            return this.$store.state.loaded;
        },
        code(){
            return this.digit1.toString() + this.digit2.toString() + this.digit3.toString() + this.digit4.toString();
        }
    },
    methods: {
        resetDigit(index){
            if (this.isPasting) return;
            let inputName = 'digit' + index;
            this[inputName] = '';
        },
        handlePaste(event) {
            event.preventDefault();
            const pastedData = event.clipboardData.getData('text');
            const digits = pastedData.replace(/\D/g, '').slice(0, 4); // Remove non-digits and take first 4
            
            if (digits.length === 4) {
                this.isPasting = true;
                
                this.digit1 = digits[0];
                this.digit2 = digits[1];
                this.digit3 = digits[2];
                this.digit4 = digits[3];
                
                // Just blur the current input, no need to focus the last one
                this.$nextTick(() => {
                    this.isPasting = false;
                    event.target.blur();
                });
            }
        },
        goBack(){
            this.$router.go(-1);
            // this.$router.push({path: '/'});
        },
    },
    watch: {
        code(newCode){
            this.$emit('change', newCode);
        },
        digit1(digit){
            if (this.isPasting) return;
            
            if (digit){
                
                if (digit.toString().length > 1){
                    window.setTimeout(()=>{
                        this.digit1 = digit.toString().slice(-1);
                    }, 50);
                }
                this.$refs.digit2Input.focus();

            }
        },
        digit2(digit){
            if (this.isPasting) return;
            
            if (digit){
                if (digit.toString().length > 1){
                    window.setTimeout(()=>{
                        this.digit2 = digit.toString().slice(-1);
                    }, 50);
                }
                this.$refs.digit3Input.focus();

            }
        },
        digit3(digit){
            if (this.isPasting) return;
            
            if (digit){
                window.setTimeout(()=>{
                    this.digit3 = digit.toString().slice(-1);
                }, 50);
                this.$refs.digit4Input.focus();
            }
        },
        digit4(digit){
            if (this.isPasting) return;
            
            if (digit){
                window.setTimeout(()=>{
                    this.digit4 = digit.toString().slice(-1);
                }, 50);
                this.$refs.digit4Input.blur();
            }
        }
    },
    mounted(){
        if(this.autoFocus){
            setTimeout(()=>{
                this.$refs.digit1Input.focus();
            }, 500);
        }
    }
}
</script>

<style lang="scss">
.code-inputs{
    direction: ltr!important;
    justify-content: center;
    gap: 12px;
    
    .v-col {
        flex: 0 0 auto;
        max-width: 80px;
        padding: 0;
    }
    
    .v-input {
        border-radius: 16px !important;
        
        ::v-deep .v-input__control {
            .v-input__slot {
                min-height: 80px !important;
                border-radius: 16px !important;
                border: 2px solid #E0E0E0 !important;
                
                fieldset {
                    border-radius: 16px !important;
                    border-color: #E0E0E0 !important;
                }
            }
            
            &:hover .v-input__slot fieldset {
                border-color: #D4780A !important;
            }
        }
        
        &.v-input--is-focused ::v-deep .v-input__slot fieldset {
            border-color: #D4780A !important;
            border-width: 2px !important;
        }
    }
    
    input {
        direction: ltr !important;
        text-align: center;
        font-weight: 600;
        font-size: 32px;
        font-family: 'Inter', sans-serif;
        color: #1E1E1E;
    }
    
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
}
</style>